/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyAppsIcon = createIcon("EmptyAppsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M85 43H27a1 1 0 00-1 1v40.333a1 1 0 001 1h58a1 1 0 001-1V44a1 1 0 00-1-1Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 35H37a3 3 0 00-3 3v35c0 1.657 3.343 4.333 5 4.333h50.813C91.469 77.333 94 74.657 94 73V38a3 3 0 00-3-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 36H38a3 3 0 00-3 3v34.333a3 3 0 003 3h52a3 3 0 003-3V39a3 3 0 00-3-3Z",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 49h40l-2.064.56A86.348 86.348 0 0037 71.333V49Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 35h54a3 3 0 013 3v9.5H34V38a3 3 0 013-3Z",
    fill: "#665AF4"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M35 46.5h58V38a2 2 0 00-2-2H37a2 2 0 00-2 2v8.5Z",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 43a1.5 1.5 0 100-3 1.5 1.5 0 000 3Zm6 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3Zm6 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.EmptyAppsIcon"
});